import { useMemo } from 'react';
import { DEVICE_TYPE, useDeviceType } from '@libs/common-next';
import type { FaqVariant } from '../components';

const config = {
    [DEVICE_TYPE.DESKTOP]: 3,
    [DEVICE_TYPE.TABLET]: 2,
    [DEVICE_TYPE.MOBILE]: 1,
};

export const useItems = <T>(items: T[], variant: FaqVariant) => {
    const deviceType = useDeviceType();

    return useMemo(() => {
        const columns = variant === 'Columns' ? config[deviceType] : 1;
        const newGroupedItems: T[][] = Array.from({ length: columns }, () => []);

        items.forEach((item, index) => {
            newGroupedItems[Math.floor(index / Math.ceil(items.length / columns))].push(item);
        });

        return newGroupedItems;
    }, [deviceType, items, variant]);
};
